module.exports = __webpack_public_path__ + "icons/original/small/small-e1.abbe71866b879431f7d1ec2f736260f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-e1.png
// module id = SCQN
// module chunks = app